import constants from '@/app-configs/constants'

export default [
  {
    path: '/apisettings',
    name: 'apisettings',
    component: () => import('@/views/settings/ApiSettings.vue'),
    meta: {
      pageTitle: 'DEBTIA_API_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_API_SETTINGS',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
]
